<template>
  <v-row>
    <v-col cols="12">
      <Filtro />
    </v-col>
    <v-col cols="12">
      <v-tabs
        v-model="tab"
        :background-color="getAppBarColor"
        class="elevation-2"
        dark
        :grow="true"
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab v-for="table in tables" :key="table" :href="`#tab-${table}`">
          <div v-if="table === 'Atrasadas'">
            <div v-if="getAtrasadas.length > 0">
              <v-badge color="#EC6A59" :content="getAtrasadas.length">{{ table }}</v-badge>
            </div>
            <div v-else>{{ table }}</div>
          </div>

          <div v-else-if="table === 'Vence Amanhã'">
            <div v-if="getVenceAmanha.length > 0">
              <v-badge color="#F9D400" :content="getVenceAmanha.length">{{ table }}</v-badge>
            </div>
            <div>{{ table }}</div>
          </div>

          <div v-else-if="table === 'Vence Hoje'">
            <div v-if="getvenceHoje.length > 0">
              <v-badge color="#F9D400" :content="getvenceHoje.length">{{ table }}</v-badge>
            </div>
            <div v-else>{{ table }}</div>
          </div>

          <div v-else>
            <div v-if="getLeads.length > 0">
              <v-badge color="#0185BA" :content="getLeads.length">{{ table }}</v-badge>
            </div>
            <div v-else>{{ table }}</div>
          </div>
        </v-tab>

        <v-tab-item v-for="table in tables" :key="table" :value="`tab-${table}`">
          <v-card flat tile>
            <Table :filter="table" />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Vendedor } from "@/services/lead";

export default {
  name: "Vendedor",

  components: {
    Filtro: () => import("./components/Filtro"),
    Table: () => import("../components/Table")
  },

  data() {
    return {
      tables: ["Atrasadas", "Vence Amanhã", "Vence Hoje", "Todas"],
      tab: null,
      serviceVendedor: new Vendedor()
    };
  },

  methods: {
    ...mapActions("leads", ["setAtrasadas"]),
    ...mapActions("leads", ["setVenceAmanha"]),
    ...mapActions("leads", ["setVenceHoje"]),

    async getLeadsAtrasadas() {
      try {
        const response = await this.serviceVendedor.getLeadsAtrasadas(
          this.getUser.cpf
        );
        this.setAtrasadas(response);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar as Leads atrasadas");
        return Promise.reject(error);
      }
    },

    async getLeadsVenceAmanha() {
      try {
        const response = await this.serviceVendedor.getLeadsVenceAmanha(
          this.getUser.cpf
        );
        this.setVenceAmanha(response);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar as Leads que vencem amanhã");
        return Promise.reject(error);
      }
    },

    async getLeadsVenceHoje() {
      try {
        const response = await this.serviceVendedor.getLeadsVenceHoje(
          this.getUser.cpf
        );
        this.setVenceHoje(response);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar as Leads que vencem hoje");
        return Promise.reject(error);
      }
    }
  },

  computed: {
    ...mapGetters("leads", ["getLeads"]),
    ...mapGetters("leads", ["getAtrasadas"]),
    ...mapGetters("leads", ["getVenceAmanha"]),
    ...mapGetters("leads", ["getvenceHoje"]),
    ...mapGetters("auth", ["getUser"]),
  },

  async mounted() {
    if (this.getAtrasadas.length === 0) {
      await this.getLeadsAtrasadas();
    }
    if (this.getVenceAmanha.length === 0) {
      await this.getLeadsVenceAmanha();
    }
    if (this.getvenceHoje.length === 0) {
      await this.getLeadsVenceHoje();
    }
  }
};
</script>
